<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close">
            <template #body>

                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-6">
                        <vs-input class="w-full" type="number" :label="$t('start_hour_hrs') | capitalize"
                            :placeholder="$t('start_hour') | capitalize" v-model="form.startHour" />
                    </div>
                    <div class="col-span-6">
                        <vs-input class="w-full" type="number" :label="$t('end_hour_hrs') | capitalize"
                            :placeholder="$t('end_hour') | capitalize" v-model="form.endHour" />
                    </div>
                    <div class="col-span-12">
                        <vs-input class="w-full" type="number" label="Pallet (USD)"
                            :placeholder="$t('price') | capitalize" v-model="form.palletPrice" />
                    </div>
                    <div class="col-span-12">
                        <vs-input class="w-full" type="number" label="Box (USD)" :placeholder="$t('price') | capitalize"
                            v-model="form.boxPrice" />
                    </div>
                    <div class="col-span-12">
                        <vs-input class="w-full" label="Bulk (USD)" :placeholder="$t('price') | capitalize"
                            v-model="form.bulkPrice" />
                    </div>
                </div>
                <vs-alert :active="alert" class="mt-4">
                    Please check the fields.
                </vs-alert>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="save" :disabled="alert">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    item: { type: Object, default: () => ({id: '',start_hour: '',end_hour: '',pallet_price: '',box_price: '', bulk_price: '' })}
})

const emit = defineEmits(['click', 'save', 'input'])
const form = ref({
    id: '',
    startHour: '',
    endHour: '',
    palletPrice: '',
    boxPrice: '',
    bulkPrice: ''
})

watch(() => props.value, (newValue) => {
    if (newValue) {
        form.value.id = props.item.id
        form.value.startHour = props.item.start_hour
        form.value.endHour = props.item.end_hour
        form.value.palletPrice = props.item.pallet_price
        form.value.boxPrice = props.item.box_price
        form.value.bulkPrice = props.item.bulk_price
    }
})

const alert = computed(() => {
  const f = form.value

  const isInvalid = (val) =>
    val === '' ||
    val === null ||
    val === undefined ||
    isNaN(val) ||
    Number(val) < 0

  return (
    isInvalid(f.startHour) ||
    isInvalid(f.endHour) ||
    isInvalid(f.palletPrice) ||
    isInvalid(f.boxPrice) ||
    isInvalid(f.bulkPrice)
  )
})

const close = () => {
    emit('input', false)
}

const save = () => {
    emit('save', { ...form.value })
}

</script>

<style></style>